import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { withTranslation } from "react-i18next";
import { motion } from "framer-motion";
import InfiniteScroll from "react-infinite-scroll-component";
import Page from "components/Page";
import styles from "../Appointments.module.scss";
import DefaultImage from "../../../../assets/images/staff-default.svg";
import { uniqBy } from "lodash";
import Empty from "components/Empty";
import Loader from "components/Loader";
import constants from "../../../../constants";
import { decodeId, encodeId } from "utils";
import Text from "components/Text";
import { useOfficeDoctor } from "repositories/patient-appointment-repository";
import {
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { AppointmentsContext } from "../AppointmentsContext";

let pageSize = 10;
const animationVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.05,
    },
  },
};
const DoctorSelection = ({ t }) => {
  const location = useLocation();
  const [doctors, setDoctors] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  let { officeId, patientId } = useParams();
  officeId = decodeId(officeId);
  const [totalItems, setTotalItems] = useState(0);
  const { setSelectedDoctor, selectedDoctor } = useContext(AppointmentsContext);
  const { data, isLoading: DoctorOfficeLoading } = useOfficeDoctor(
    officeId,
    pageNumber,
    pageSize
  );

  const history = useHistory();
  const goBack = () => {
    history.goBack();
  };

  useEffect(() => {
    if (pageNumber === 1) {
      if (!DoctorOfficeLoading && data?.items) {
        setDoctors(uniqBy([...data?.items], "id"));
        setTotalItems(data?.totalItems);
      }
    } else if (!DoctorOfficeLoading && data?.items) {
      setDoctors((prev) => uniqBy([...prev, ...data?.items], "id"));
      setTotalItems(data?.totalItems);
    }
  }, [DoctorOfficeLoading]);

  return (
    <Page
      onBack={goBack}
      className={styles["main-page"]}
      title={t("patientAppointmentMembers.patientAppointments")}
    >
      {DoctorOfficeLoading && <Loader />}

      <Text size="14" weight="300" color="#000000">
        {t("patientAppointmentMembers.selectDoctor")}
      </Text>

      <div className="margin30">
        {doctors?.length === 0 ? (
          <div className={styles["not_found"]}>
            <Empty Message={t("taskManagement.taskNotFound")} />
          </div>
        ) : (
          <motion.div
            variants={animationVariants}
            initial="hidden"
            animate="show"
            className="w-100"
          >
            <InfiniteScroll
              className="w-100"
              dataLength={doctors?.length}
              hasMore={doctors?.length < totalItems}
              next={() => setPageNumber((v) => v + 1)}
            >
              <div className={styles["card-con"]}>
                {doctors?.map((doctor) => (
                  <Link
                    key={doctor?.id}
                    to={{
                      pathname:
                        constants.routes.appointment.patientNewAppointment
                          .replace(":officeId?", encodeId(officeId))
                          .replace("/:doctorId?", `/${encodeId(doctor?.id)}`)
                          .replace(
                            "/:patientId?",
                            patientId ? `/${patientId}` : ""
                          ),
                      state: {
                        ...location.state,
                      },
                    }}
                    onClick={() => setSelectedDoctor(doctor)}
                  >
                    <div className={styles["urban-dental-card"]}>
                      <div className={styles["urban-dental-logo"]}>
                        <img
                          heigth={100}
                          width={100}
                          src={doctor?.profilePic || DefaultImage}
                          alt="urban dental logo"
                        />
                      </div>
                      <div className={styles["urban-dental-text"]}>
                        {doctor?.firstName}
                      </div>
                    </div>
                  </Link>
                ))}
              </div>
            </InfiniteScroll>
          </motion.div>
        )}
      </div>
    </Page>
  );
};
export default withTranslation()(DoctorSelection);
